import { useGetProductsLoadMore } from "hooks/serial";
import { useState } from "react";

function useSelectProduct({ handleGetProduct }) {
  const [params, setParams] = useState({
    filters: {
      query: undefined,
      vatTypes: ["REQUIRED", "NOT_REQUIRED"],
    },
    pagination: { offset: 0, limit: 10 },
  });

  // Defer the query until the user actually opens/searches the select,
  // instead of firing as soon as this component mounts.
  const [hasInteracted, setHasInteracted] = useState(false);

  const { data, onLoadMoreData, hasMoreData, loading } = useGetProductsLoadMore(
    params,
    "cache-first",
    !hasInteracted
  );

  const onFocus = () => setHasInteracted(true);

  const onSearch = (value) => {
    setHasInteracted(true);
    setParams({
      filters: { ...params.filters, query: value || undefined },
      pagination: { offset: 0, limit: 10 },
    });
  };

  const handleChange = (value, option) => {
    handleGetProduct && handleGetProduct({ ...option?.product });
  };

  return {
    onLoadMoreData,
    hasMoreData,
    loading,
    onFocus,
    onSearch,
    handleChange,
    data,
  };
}

export default useSelectProduct;
